import React from 'react';
import { FloatButton } from 'antd';
import { QuestionOutlined } from '@ant-design/icons';
import { DOCS_URLS } from '../../constants/docs';

// Justo encima del footer fijo, que mide unos 56 px. El margen derecho acompaña al de la página
// (1% del ancho, más las barras de scroll) para que el botón quede dentro de la caja blanca.
const HelpFloatButton = () => (
  <FloatButton
    className="help-float-btn"
    icon={<QuestionOutlined />}
    type="primary"
    href={DOCS_URLS.guides}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Guías y ayuda"
    tooltip="Guías y ayuda"
    style={{ right: 'calc(1vw + 24px)', bottom: 72, width: 40, height: 40 }}
  />
);

export default HelpFloatButton;
